import React from "react"
import styled from "styled-components"

import Icon from "~/components/atoms/Icon"
import { ButtonStyle, StyledBySize } from "~/consts/button-style"
import { Color, SpacingSize } from "~/consts/style-mixins"

interface Props {
  children: string | React.ReactNode
  size: keyof typeof SizeType
  onClick: Function
  disabled?: boolean
  isLoading?: boolean
  className?: string
  type?: "button" | "submit" | "reset" | undefined
  variant?: "contained" | "outlined"
}

export const SizeType = {
  Medium: "Medium",
  Small: "Small",
}

const Button = ({
  children,
  size,
  disabled,
  isLoading,
  onClick,
  className,
  type = "button",
  variant = "contained",
}: Props) => {
  return (
    <StyledButton
      type={type}
      className={className}
      styledBySize={StyledBySize[size]}
      disabled={Boolean(disabled) || Boolean(isLoading)}
      variant={variant}
      onClick={
        onClick &&
        (() => {
          if (!disabled) {
            onClick()
          }
        })
      }
    >
      {isLoading && (
        <Icon type="Loading" size={size === "Small" ? 14 : 16} color={Color.Primary} className="isLoading" />
      )}
      {children}
    </StyledButton>
  )
}

export default Button

const StyledButton = styled.button`
  ${ButtonStyle};
  .isLoading {
    margin-right: ${SpacingSize["3XS"]}px;
  }
`
